import { connectingToOneDriveText } from './ProviderFolderView.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { getErrorString, isAnyError } from '../selectors/errorSelectors';
import { getFileProviderName } from '../selectors/fileProviderSelectors';
import { getIconForOneDrive } from 'owa-fileprovider-icon';

import { getSelectedFolderName } from '../selectors/selectedFolderSelectors';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { isLoading } from '../selectors/loadingSelectors';
import { observer } from 'mobx-react-lite';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

const styles = require('./ProviderFolderView.scss');
const classNames = require('classnames');

export const ProviderFolderView = observer(function ProviderFolderView() {
    const folderName = getSelectedFolderName();
    const fileProviderName = getFileProviderName();
    const loading = isLoading();

    return (
        <div className={styles.container}>
            <div className={styles.icon}>
                {loading ? <Spinner size={SpinnerSize.medium} /> : getIcon()}
            </div>
            <div className={loading ? styles.loadingContent : styles.content}>
                {loading ? (
                    loc(connectingToOneDriveText)
                ) : (
                    <FileProviderView fileProviderName={fileProviderName} folderName={folderName} />
                )}
            </div>
        </div>
    );
});

const FileProviderView = observer(function FileProviderView(props: {
    fileProviderName: string;
    folderName: string;
}) {
    const errorString = isAnyError() ? getErrorString() : null;
    return (
        <>
            <div className={styles.providerName}>{props.fileProviderName}</div>
            {errorString ? (
                <div className={classNames(styles.folderInfo, styles.errorInfo)}>
                    <Icon className={styles.folderIcon} iconName={ControlIcons.Error} />
                    {errorString}
                </div>
            ) : (
                <div className={styles.folderInfo}>
                    <Icon className={styles.folderIcon} iconName={ControlIcons.FabricFolder} />
                    {props.folderName}
                </div>
            )}
        </>
    );
});

function getIcon(): JSX.Element {
    // We get the bigger icon so that we can scale it down to the needed size
    return getIconForOneDrive(true /* isBigIcon */, styles.oneDriveIcon);
}
